export const purchasing = {
  description: "الموردون وأوامر الشراء وسندات الاستلام.",
  contact: "جهة الاتصال",
  order: "الأمر",
  supplier: "المورد",
  job: "أمر العمل",
  addSupplier: "إضافة مورد",
  newPurchaseOrder: "أمر شراء جديد",
  suppliers: "الموردون",
  purchaseOrders: "أوامر الشراء",
  emptyTitle: "لا توجد أوامر شراء",
  emptyDescription: "أنشئ أمراً لشراء مخزون أو الاستعانة بعملية خارجية.",
  selectOrder: "اختر أمر شراء لعرض البنود والكميات المتبقية وسندات الاستلام.",
  createOrder: "إنشاء الأمر",
  forJob: "لأمر العمل (اختياري)",
  noneStockOrder: "لا شيء (أمر مخزون)",
  lines: "البنود",
  addLine: "إضافة بند",
  unitCost: "تكلفة الوحدة",
  createdToast: "تم إنشاء أمر الشراء",
  forJobText: "لأمر العمل {number}",
  expected: "متوقع {date}",
  receivedCount: "{received}/{ordered} مستلم",
  outstandingCount: "{outstanding} متبقٍ",
  receipts: "سندات الاستلام",
  ref: "مرجع {reference}",
  receive: "استلام",
  cancelledToast: "تم إلغاء أمر الشراء",
  location: "الموقع",
  supplierReference: "مرجع المورد",
  supplierReferenceHint: "رقم إشعار التسليم أو الفاتورة.",
  receiving: "جارٍ الاستلام…",
  recordReceipt: "تسجيل الاستلام",
  receiptRecorded: "تم تسجيل الاستلام",
  outstandingNote: "(المتبقي {outstanding})",
  addSupplierTitle: "إضافة مورد",
  saveSupplier: "حفظ المورد",
  paymentNote: "ملاحظة الدفع",
  addedToast: "تمت إضافة المورد",
};
